export const nl: Record<string, unknown> = {
  meta: {
    title: 'TimeLock — tijdslot voor bestanden',
    description: 'Versleutel bestanden die pas op een gekozen moment ontsleuteld kunnen worden. Alles in je browser.',
  },
  tabs: {
    encrypt: 'Versleutelen',
    decrypt: 'Ontsleutelen',
  },
  footer: {
    link: 'Hoe werkt dit? Waarom is dit veilig?',
  },
  encrypt: {
    step1: 'Kies een bestand',
    step2: 'Kies een beleid',
    step3: 'Kies het moment',
    step4: 'Versleutel',
    dropzone: 'Sleep hier een bestand of klik om te bladeren',
    large_file: 'Groot bestand — versleutelen kan even duren',
    policy_time: 'Tijd',
    policy_time_manual: 'Tijd + handmatig',
    policy_manual: 'Alleen handmatig',
    desc_time: 'De ontsleutelsleutel komt automatisch beschikbaar op het gekozen tijdstip. Niemand — ook jij niet — kan eerder ontsleutelen.',
    desc_manual: 'De sleutel wordt alleen vrijgegeven als jij dat zelf doet met het sleutelbestand. Er is geen tijd.',
    desc_time_manual: 'De sleutel komt beschikbaar op het tijdstip, óf eerder als jij hem handmatig vrijgeeft.',
    btn_encrypt: 'Versleutel bestand',
    encrypting: 'Versleutelen…',
    err_no_file: 'Kies eerst een bestand.',
    err_invalid_time: 'Ongeldig tijdstip.',
    err_future_time: 'Kies een tijdstip in de toekomst.',
    err_unknown: 'Onbekende fout',
    confirm_time: 'Versleuteld. Het bestand kan pas op het gekozen tijdstip worden geopend.',
    confirm_manual: 'Versleuteld. Het bestand kan alleen met het sleutelbestand worden vrijgegeven.',
    confirm_time_manual: 'Versleuteld. Het bestand opent op het gekozen tijdstip, of eerder als jij het vrijgeeft.',
    key_meta_manual: 'Enige manier om vrij te geven',
    key_meta_time_manual: 'Bewaar veilig — voor vervroegd vrijgeven',
    btn_reset: 'Opnieuw beginnen',
    btn_goto_decrypt: 'Bekijk in Ontsleutelen →',
    aria_encrypted_file: 'Versleuteld bestand {name}',
    aria_key_file: 'Sleutelbestand {name}',
    title_drag: 'Sleep naar je Downloads-map of klik op het pijltje',
    title_share: 'Delen',
    title_save: 'Opslaan',
  },
  decrypt: {
    import_title: 'Importeer bestanden',
    dropzone: 'Sleep hier .tlck of .tlck-key bestanden of klik om te bladeren',
    help: 'Een <strong>.tlck</strong> bestand wordt in de wachtrij gezet om te ontsleutelen. Een <strong>.tlck-key</strong> bestand geeft het slot vrij zodat de ontvanger kan ontsleutelen.',
    import_error: '{name} is geen geldig .tlck bestand',
    queue_title: 'Wachtrij',
    queue_empty: 'Nog geen bestanden geïmporteerd.',
    policy_time: 'Tijd',
    policy_time_manual: 'Tijd + handmatig',
    policy_manual: 'Alleen handmatig',
    badge_waiting_manual: 'Wacht op handmatige vrijgave',
    btn_decrypt: 'Ontsleutel',
    decrypting: 'Ontsleutelen…',
    decrypted: 'Ontsleuteld',
    decrypt_failed: 'Ontsleutelen mislukt',
    btn_retry: 'Opnieuw proberen',
    title_download_tlck: 'Download .tlck opnieuw',
    title_remove: 'Verwijderen uit wachtrij',
    aria_remove: 'Verwijderen',
    aria_decrypted_file: 'Ontsleuteld bestand {name}',
    title_drag: 'Sleep naar je Downloads-map of klik op het pijltje',
    title_share: 'Delen',
    title_save: 'Opslaan',
    release_invalid_key: 'Ongeldig sleutelbestand.',
    release_success: 'Slot vrijgegeven! Het bestand kan nu ontsleuteld worden.',
    release_failed: 'Vrijgeven mislukt. Controleer het sleutelbestand en probeer het opnieuw.',
    release_confirm: '<strong>{name}</strong> — Dit is een sleutelbestand. Wil je dit slot vrijgeven? Na vrijgave kan iedereen met het .tlck bestand ontsleutelen.',
    release_btn_confirm: 'Ja, vrijgeven',
    release_btn_cancel: 'Annuleren',
    release_working: 'Bezig met vrijgeven…',
  },
  errors: {
    file_too_small: 'Bestand te klein',
    file_corrupted: 'Bestand beschadigd',
    no_valid_preamble: 'Geen geldige preamble',
    no_separator: 'Geen scheiding gevonden',
    header_unreadable: 'Header niet leesbaar',
    unknown_version: 'Onbekende versie',
    no_key_available: 'Geen sleutel beschikbaar',
  },
  notfound: {
    title: 'Pagina niet gevonden',
    body: 'De pagina die je zoekt bestaat niet. Maar je sleutels zijn veilig!',
    back: '← Terug naar TimeLock',
  },
  about: {
    back: '← Terug',
    title: 'Hoe werkt TimeLock?',
    section_browser_title: 'Alles in je browser',
    section_browser_body: '<p>Het bestand dat je versleutelt verlaat je browser nooit in leesbare vorm. Alle cryptografie gebeurt lokaal. De server ontvangt alleen wat strikt nodig is om handmatige vrijgave mogelijk te maken — en zelfs dan nooit het bestand zelf.</p>',
    section_policies_title: 'Drie beleidsopties, twee mechanismen',
    section_policies_body: '<ul><li><strong>Tijd.</strong> We gebruiken <a href="https://drand.love" target="_blank" rel="noopener">drand</a> met het <em>tlock</em>-protocol. Je bestand wordt versleuteld naar een toekomstige drand-ronde. Pas wanneer het drand-netwerk — een gedecentraliseerd threshold-consortium — op dat moment de bijbehorende signatuur publiceert, kan het worden ontsleuteld. <em>Onze server speelt hier geen rol en bewaart niets.</em> Ook wij kunnen het niet eerder openen.</li><li><strong>Alleen handmatig.</strong> Het sleutelwerk is bewust gesplitst:<ul><li>Je <strong>eigendomssleutel</strong> (ECDSA P-256) wordt in je browser gemaakt. De publieke helft gaat naar de server; de private helft zit in het <code>.tlck-key</code> bestand dat jij downloadt.</li><li>De <strong>ontsleutelsleutel</strong> (X25519) wordt door de server gemaakt. Alleen de publieke helft wordt naar je browser gestuurd, zodat je bestand daarnaar versleuteld kan worden. De private helft verlaat de server nooit onversleuteld.</li></ul>Pas na een succesvolle challenge-response — waarbij jij met je eigendomssleutel een door de server uitgegeven eenmalige <em>nonce</em> tekent — geeft de server de ontsleutelsleutel vrij aan de ontvanger.</li><li><strong>Tijd + handmatig.</strong> Het bestand wordt naar twee ontvangers tegelijk versleuteld: de drand-ronde én de ontsleutelsleutel van de server. Wat het eerst beschikbaar is — tijd of handmatige vrijgave — opent het bestand.</li></ul>',
    section_server_title: 'Wat weet de server?',
    section_server_body: '<p>Zo weinig mogelijk:</p><ul><li>Voor tijd-gebonden sloten: <strong>helemaal niets</strong>. Deze raken de server nooit.</li><li>Voor handmatige sloten: een willekeurig slot-ID en één <em>AEAD-verzegelde blob</em> die zowel de private ontsleutelsleutel als je publieke eigendomssleutel bevat. Deze blob wordt versleuteld met een sleutel die alleen in het geheugen van de server leeft — niet in de database.</li><li>Geen bestandsnaam, geen grootte, geen accounts, geen IP-adressen buiten wat kortstondig nodig is voor rate-limiting.</li></ul>',
    section_blob_title: 'Waarom één verzegelde blob?',
    section_blob_body: '<p>Een aanvaller die toegang krijgt tot de database — maar niet tot de serverprocessen — zou anders de publieke eigendomssleutel kunnen verwisselen en zo een eigen handtekening laten verifiëren. Door beide sleutels samen te verzegelen, met het slot-ID, het beleid én het ontgrendeltijdstip als <em>additional authenticated data</em>, wordt elke manipulatie cryptografisch gedetecteerd: een omgedraaide byte, een blob die tussen rijen wordt verplaatst, of een gewijzigd beleid of tijdstip — alles faalt de integriteitscheck en wordt afgewezen.</p>',
    section_integrity_title: 'Integriteit van het bestand zelf',
    section_integrity_body: '<p>Elk <code>.tlck</code>-bestand draagt een SHA-256 controlesom. Een beschadigd bestand wordt herkend en geweigerd nog vóór enige ontsleutelpoging — zo verspillen we geen cyclen aan corrupte invoer. Let op: dit is een corruptiecheck, geen authenticatie — de echte beveiliging tegen opzettelijke manipulatie komt van de binnenliggende AEAD-versleuteling.</p>',
    section_keyfile_title: 'Bewaar je sleutelbestand goed',
    section_keyfile_body: '<p>Het <code>.tlck-key</code> is het enige bewijs van eigendom. Er is bewust geen herstelprocedure: kwijt betekent dat handmatige vrijgave niet meer mogelijk is. Dat is geen bug — het is precies de eigenschap die ervoor zorgt dat ook <em>wij</em> niet namens jou kunnen vrijgeven.</p>',
  },
};
